import type { RhodesVariant } from "@/store/map"
import type { RegionId } from "@/types"

export interface BadgeConfig {
    labelBg: string
    labelHeight: number
    labelName: string
    logo: string
    logoWidth: number
    logoHeight: number
    logoMargin?: [left: number, right: number]
    paddingBottom?: number
    locationIconFilter?: string
}

type BadgeKey = RegionId | `babel_rhodes_${"a" | "b"}`

export const BADGE_CONFIG: Partial<Record<BadgeKey, BadgeConfig>> = {
    sargon: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "SARGON",
        logo: require("@/assets/imgs/map/sargon/map-sargon-label-logo.png"),
        logoWidth: 106,
        logoHeight: 84,
        logoMargin: [0, -14],
    },
    kazdel: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "KAZDEL",
        logo: require("@/assets/imgs/map/kazdel/map-kazdel-logo.png"),
        logoWidth: 93,
        logoHeight: 103,
        paddingBottom: 12,
        logoMargin: [8, 12],
        locationIconFilter: "hue-rotate(0deg) saturate(1.2) grayscale(0.2)",
    },
    sami: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "SAMI",
        logo: require("@/assets/imgs/map/sami/map-sami-label-logo.png"),
        logoWidth: 99,
        logoHeight: 98,
        logoMargin: [8, 12],
        paddingBottom: 12,
        locationIconFilter: "hue-rotate(220deg) brightness(1.4) grayscale(0.3)",
    },
    ursus: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "URSUS",
        logo: require("@/assets/imgs/map/ursus/map-ursus-label-icon.png"),
        logoWidth: 113,
        logoHeight: 83,
        logoMargin: [8, 12],
        paddingBottom: 12,
        locationIconFilter: "hue-rotate(221deg) saturate(0.5) brightness(1.7)",
    },
    victoria: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "VICTORIA",
        logo: require("@/assets/imgs/map/victoria/map-victoria-label-logo.png"),
        logoWidth: 102,
        logoHeight: 80,
        logoMargin: [8, 12],
        paddingBottom: 12,
        locationIconFilter: "hue-rotate(43deg) saturate(0.6) brightness(1.2)",
    },
    leithanien: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "LEITHANIA",
        logo: require("@/assets/imgs/map/leithania/map-leithania-label-icon.png"),
        logoWidth: 115,
        logoHeight: 91,
        logoMargin: [8, 12],
        paddingBottom: 12,
        locationIconFilter: "hue-rotate(234deg) saturate(0.7) brightness(1.2)",
    },
    babel_rhodes: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "RHODES ISLAND",
        logo: require("@/assets/imgs/map/rhodes/map-rhodes-label-icon.png"),
        logoWidth: 103,
        logoHeight: 88,
        paddingBottom: 16,
        locationIconFilter: "hue-rotate(197deg) saturate(0.7) brightness(1.7)",
    },
    babel_rhodes_a: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "RHODES ISLAND",
        logo: require("@/assets/imgs/map/rhodes/map-rhodes-label-icon.png"),
        logoWidth: 103,
        logoHeight: 88,
        paddingBottom: 16,
        locationIconFilter: "hue-rotate(197deg) saturate(0.7) brightness(1.7)",
    },
    babel_rhodes_b: {
        labelBg: require("@/assets/imgs/map/map-label-bg.png"),
        labelHeight: 41,
        labelName: "RHODES ISLAND",
        logo: require("@/assets/imgs/map/rhodes/map-rhodes-label-icon.png"),
        logoWidth: 103,
        logoHeight: 88,
        paddingBottom: 16,
        locationIconFilter: "hue-rotate(197deg) saturate(0.7) brightness(1.7)",
    },
}

export function getRhodesBadgeKey(variant: RhodesVariant | null): BadgeKey {
    return variant ? `babel_rhodes_${variant}` : "babel_rhodes"
}
